import ToolManagementLandingPage from "../../components/toolManagement/ToolManagementLandingPage";

export default ToolManagementLandingPage;
